import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=637510f9&scoped=true&lang=html&"
import script from "./Booking.vue?vue&type=script&lang=js&"
export * from "./Booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637510f9",
  null
  
)

export default component.exports